module.exports = __webpack_public_path__ + "media/images/logo-771e8937c5cda25c42c4259640657171.png";